


export class CsvMappingFields {
  IGNORE = 1
  CUSTOM = 2
  AMOUNT= 3
  DATE= 4
  CURRENCY= 5
  REVENUE_CODE= 6
  TAX_ID= 7
  COMPANY_NAME= 8
  COMPANY_CUSTOM_PROPERTY= 9
  LINK= 10
  TRANSACTION_DATE= 11
  dropDownList = [{"value": this.IGNORE, "name": "Ignore"}, {"value": this.CUSTOM, "name": "Custom"},
    {"value": this.AMOUNT, "name": "Amount"}, {"value": this.DATE, "name": "Date", format: ""},
    {"value": this.TRANSACTION_DATE, "name": "Transaction Date", format: ""},
    {"value": this.CURRENCY, "name": "Currency"},
    {"value": this.LINK, "name": "Link"},
    {"value": this.REVENUE_CODE, "name": "Revenue Code"},{"value":this.TAX_ID,"name":"Tax Id"},
    {"value": this.COMPANY_NAME, "name": "Company Name"}, {"value":this.COMPANY_CUSTOM_PROPERTY, "name": "Company Custom Property"}];

  // One definition of "numeric column": Amount, or Currency with an explicit
  // currencyCode. Legacy Currency columns without currencyCode hold the row's
  // currency code as text and must stay non-numeric. `type` is stored as
  // string or number depending on the format's age, hence String().
  static isAmountColumn(mo: any): boolean {
    const type = String(mo?.type);
    return type === '3' || (type === '5' && !!mo?.currencyCode);
  }

  // Date ('4') or Transaction Date ('11').
  static isDateColumn(mo: any): boolean {
    const type = String(mo?.type);
    return type === '4' || type === '11';
  }
}
